// "คัดลอกลิงก์แชท": a link to one conversation (/c/:id) that a teammate can open. The API decides who may see
// it (signed in through POS "แชทรวม"); someone not signed in lands on the sign-in page, and after signing in
// through POS they come back to the same chat (owner 26 ก.ย. 69: "กด copy ลิ้งส่งหากันได้สำหรับคนที่ login และมีสิทธ์ดู").

const RETURN_KEY = 'cf-chat.return-to'
const RETURN_TTL_MS = 30 * 60 * 1000 // the POS round trip takes seconds; an old link must not hijack a later visit

export function chatLink(convId: string, origin: string = window.location.origin): string {
  return `${origin}/c/${encodeURIComponent(convId)}`
}

/** Only in-app chat links are remembered (never an arbitrary URL). */
export function isChatPath(path: string): boolean {
  return /^\/c\/[A-Za-z0-9_-]{1,40}$/.test(path)
}

export function rememberReturn(path: string, now: number = Date.now()): void {
  if (!isChatPath(path)) return
  try {
    localStorage.setItem(RETURN_KEY, JSON.stringify({ path, at: now }))
  } catch {
    /* private window / blocked storage: the link still works for signed-in people */
  }
}

/** The chat link someone opened before signing in (once; expired entries are dropped). */
export function takeReturn(now: number = Date.now()): string | null {
  try {
    const raw = localStorage.getItem(RETURN_KEY)
    if (!raw) return null
    localStorage.removeItem(RETURN_KEY)
    const v = JSON.parse(raw) as { path?: unknown; at?: unknown }
    if (typeof v.path !== 'string' || typeof v.at !== 'number' || !isChatPath(v.path)) return null
    return now - v.at <= RETURN_TTL_MS ? v.path : null
  } catch {
    return null
  }
}

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    /* fall back below (http, older browsers, denied permission) */
  }
  try {
    const t = document.createElement('textarea')
    t.value = text
    t.setAttribute('readonly', '')
    t.style.position = 'fixed'
    t.style.left = '-9999px'
    document.body.appendChild(t)
    t.select()
    const ok = document.execCommand('copy')
    t.remove()
    return ok
  } catch {
    return false
  }
}
